import React, { useState } from "react";
import moment from 'moment';
import ModalDialog from 'react-bootstrap/Modal';
import { animalAssets } from'../../../services/constant';

import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
const InfoModal = ({ setInfoShow, infoShow, infoList }) => {
    const [anchorElValue, setAnchorElValue] = React.useState(null);
    const [iconvalue, setIconvalue] = useState('');
    const [openPopUpId, setOpenPopUpId] = useState(null);
    const openValue = Boolean(anchorElValue);
    const idValue = openValue ? 'simple-popover' : undefined;


    infoList.consumption_entries?.sort((a, b) => {
        if (a.entity_description < b.entity_description) {
            return -1;
        }
        if (a.entity_description > b.entity_description) {
            return 1;
        }
        return 0; // If they are equal
    });

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    const handlPopUpValue = (e, value, id) => {
        setAnchorElValue(e.currentTarget);
        setIconvalue(value);
        setOpenPopUpId(id);
    };
    const handlePopUpCloseValue = () => {
        setAnchorElValue(null);
        setIconvalue('');
        setOpenPopUpId(null);
    };
    return (
        <div className="info_modal">
            <ModalDialog
                show={infoShow}
                size="xl"
                onHide={() => setInfoShow(false)}
                aria-labelledby="modal-lg"
                centered
            >
                <ModalDialog.Header closeButton style={{ backgroundColor: '#F2F5F8', height: '6.8rem' }}>
                    <ModalDialog.Title id="modal-lg" className="font-24-600 font-color font-center" style={{ marginLeft: 'auto' }}>
                        Informação da Visita
                    </ModalDialog.Title>
                </ModalDialog.Header>
                <ModalDialog.Body>
                    {
                        infoList.occurrence_date ? (
                            <div className="flex-column p-24-1">
                                <div className="flex-row font-14-500 mb-2">
                                    <span className="font-color">Data da visita </span>
                                    <span className="font-grey ml-2">{moment(infoList.occurrence_date).format('DD/MM/YYYY [às] HH:mm')}</span>
                                </div>
                                <div className="flex-column mb-2">
                                    {

                                        infoList.consumption_entries.map((item) =>
                                        (
                                            <section className="modal_content_border flex-row mb-1">
                                                <div className="border_right_line m-17-1 flex-row w--25" >
                                                    <span className="font-16-500 font-center">{item.entity_description}</span>
                                                </div>
                                                <div className="border_right_line m-17-1 flex-row w--40">
                                                    <span className="font-13-400 font-center mr-1">PVP:</span>
                                                    <span className="font-15-700 font-center mr-2 w--35-1">{item.list_price_amount_at_consumption === null ? 0 : item.list_price_amount_at_consumption}&euro;</span>

                                                    <span className="font-13-400 font-center mr-1">A Cargo do Cliente:</span>
                                                    <span className="font-15-700 font-center mr-2 w--35-1">{item.copayment_amount_at_consumption === null ? 0 : item.copayment_amount_at_consumption}&euro;</span>

                                                    <span className="font-13-400 font-center mr-1">A Cargo da Seguradora:</span>
                                                    <span className="font-15-700 font-center mr-1"></span>

                                                    <button className="custom-button mr-1" onClick={(e) => handlPopUpValue(e, item.entity_id, item.id)}><img src={iconvalue === item.entity_id ? animalAssets.ic_eye : animalAssets.ic_eye_active} alt="" /></button>
                                                    <Popover
                                                        id={item.id}
                                                        open={openPopUpId === item.id}
                                                        anchorEl={anchorElValue}
                                                        onClose={handlePopUpCloseValue}
                                                        anchorOrigin={{
                                                            vertical: 'bottom',
                                                            horizontal: 'right',
                                                        }}
                                                        transformOrigin={{
                                                            vertical: 'top',
                                                            horizontal: 'right',
                                                        }}
                                                        sx={{
                                                            marginTop: '0.5rem',
                                                            '& .MuiPaper-root': {
                                                                border: '1px solid #fff',
                                                                borderRadius: '1.1rem',
                                                                minWidth: '26.7rem',
                                                                boxShadow: '0px 0px 23px 0px rgba(0, 0, 0, 0.15)',
                                                            },
                                                        }}
                                                    >
                                                        <Typography className="flex-column" style={{ padding: '2rem', width: '100%' }}>
                                                            <div className="flex-row font-left" >
                                                                <span className="font-13-700 font-color">Valor Convencionado Medipet:  </span>
                                                                <span className="font-grey font-13-700" style={{ position: 'absolute', right: '30px' }}>{item.agreed_amount_at_consumption ? item.agreed_amount_at_consumption : 0} </span>
                                                            </div>
                                                            <div className="flex-row font-left" >
                                                                <span className="font-13-700 font-color">A Cargo do cliente:  </span>
                                                                <span className="font-grey font-13-700" style={{ position: 'absolute', right: '30px' }}>{item.copayment_amount_at_consumption ? item.copayment_amount_at_consumption : 0} </span>
                                                            </div>
                                                            <div className="flex-row font-left" >
                                                                <span className="font-13-700 font-color">A Cargo da Seguradora:  </span>
                                                                <span className="font-grey font-13-700" style={{ position: 'absolute', right: '30px' }}>{item.coinsurance_amount_at_consumption ? item.coinsurance_amount_at_consumption : 0} </span>
                                                            </div>
                                                        </Typography>
                                                    </Popover>
                                                </div>
                                                <div className=" m-17-1 flex-row " style={{position:"absolute", right:'40px'}}>
                                                    <span className="font-13-400 font-center mr-1">Data:</span>
                                                    <span className="font-15-700 font-center mr-2">{formatDate(item.consumption_date)}</span>

                                                    <span className="font-13-400 font-center mr-1">Qt:</span>
                                                    <span className="font-15-700 font-center mr-2">{item.quantity}</span>
                                                </div>
                                            </section>
                                        ))
                                    }
                                </div>
                                <div className="flex-row mb-2">
                                    <button className="custom-button mr-1" ><img src={animalAssets.ic_editable_inactive} alt="" /></button>
                                    <span className="font-15-400 font-color">Notas Adicionais</span>
                                </div>
                                <div className="flex-row font-14-500">
                                    <span className="font-grey mr-1">{infoList.description} </span>
                                </div>
                            </div>
                        ) : (<></>)
                    }
                </ModalDialog.Body>
            </ModalDialog>
        </div>
    )
}

export default InfoModal;